module.exports = __webpack_public_path__ + "media/images/MFP_logo_RGB_arany-df8bb58a2345da456b51fdaff714c6e5.png";